import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { AuthProvider } from '@context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer} from 'react-toastify';
import ReactModal from "react-modal";
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';
import {GlobalHeavyLoading} from '@components';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분
      retry: 2,
    },
  },
});

function App() {
  ReactModal.setAppElement("#root"); 
  return (
    <>
    <GlobalHeavyLoading />
    <QueryClientProvider client={queryClient}>
      <Router>
      <HelmetProvider>
        <AuthProvider>
          <AppRoutes />
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} closeOnClick />
        </AuthProvider>
      </HelmetProvider>
      </Router>
     
    </QueryClientProvider>
    </>
  );
}

export default App;
